import React from "react";
import PropTypes from "prop-types";
import {compose} from "redux";
import {connect} from "react-redux";
import {Tr} from "@esnpm/translate";
import {mapShopModeToProps} from "../../lib/shopMode";

/*
	Short inline note next to a control that view-only mode has disabled.
	Renders nothing while the shop is running normally.
*/
class CatalogModeHint extends React.Component {
	static propTypes = {
		catalogMode: PropTypes.bool
	};

	render() {
		if (!this.props.catalogMode) return null;

		return (
			<p className={"CatalogModeHint text-muted small"}>
				<Tr path={"shopMode.Catalog.Hint"}/>
			</p>
		);
	}
}

export default compose(
	connect(mapShopModeToProps)
)(CatalogModeHint);
